import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "feedback"]
  static values = { text: String, silent: Boolean }

  copy(event) {
    event.preventDefault()
    const text = this.hasTextValue ? this.textValue : this.sourceTarget.value
    this.copyToClipboard(text)
  }

  copyToClipboard(text) {
    const showFeedback = () => {
      if (this.silentValue && this.hasFeedbackTarget) {
        this.feedbackTarget.classList.remove("hidden")
        clearTimeout(this._feedbackTimeout)
        this._feedbackTimeout = setTimeout(() => {
          this.feedbackTarget.classList.add("hidden")
        }, 2000)
      } else if (!this.silentValue) {
        const button = this.element.querySelector("button")
        const originalText = button.innerHTML
        button.innerHTML = `
          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          Copied!
        `
        setTimeout(() => { button.innerHTML = originalText }, 2000)
      }
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(showFeedback).catch(() => {
        this.fallbackCopy(text, showFeedback)
      })
    } else {
      this.fallbackCopy(text, showFeedback)
    }
  }

  // Fallback for iOS < 13.4 and other environments where Clipboard API is missing or fails.
  // On iOS, the element must be focusable/visible in the DOM (opacity 0 is ok).
  fallbackCopy(text, onSuccess) {
    const input = document.createElement("input")
    input.setAttribute("value", text)
    input.setAttribute("readonly", "")
    input.style.position = "fixed"
    input.style.top = "0"
    input.style.left = "0"
    input.style.width = "2em"
    input.style.height = "2em"
    input.style.padding = "0"
    input.style.border = "none"
    input.style.outline = "none"
    input.style.opacity = "0"
    document.body.appendChild(input)
    input.focus()
    input.select()
    input.setSelectionRange(0, text.length)
    try {
      if (document.execCommand("copy")) onSuccess()
    } finally {
      document.body.removeChild(input)
    }
  }
} 